// Small inline-styled form primitives for Gunsmith's panels, in the same
// var(--ss-*, fallback) style CharacterStudio.tsx already uses so this reads
// consistently with the rest of Studio without depending on sstk-sunder-web's
// own SettingControls.tsx (different repo, its own stylesheet classes).

export function Slider({
  label,
  value,
  min,
  max,
  step,
  format,
  onChange,
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  format: (v: number) => string;
  onChange: (v: number) => void;
}) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ width: 92, flexShrink: 0, fontSize: 11.5, color: 'var(--ss-text-2, #8b929c)' }}>{label}</span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ flex: 1, minWidth: 0, accentColor: 'var(--ss-accent, #6444d6)' }}
      />
      <span style={{ width: 44, flexShrink: 0, textAlign: 'right', fontSize: 11, fontVariantNumeric: 'tabular-nums', color: 'var(--ss-text, #dfe3e8)' }}>
        {format(value)}
      </span>
    </label>
  );
}

export function ColorField({ label, value, onChange }: { label: string; value: number; onChange: (hex: number) => void }) {
  const hex = `#${value.toString(16).padStart(6, '0')}`;
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ width: 92, flexShrink: 0, fontSize: 11.5, color: 'var(--ss-text-2, #8b929c)' }}>{label}</span>
      <input
        type="color"
        value={hex}
        onChange={(e) => onChange(parseInt(e.target.value.slice(1), 16))}
        style={{ width: 30, height: 24, padding: 0, border: '1px solid var(--ss-border-soft, rgba(255,255,255,0.08))', borderRadius: 5, background: 'none' }}
        aria-label={label}
      />
      <span style={{ flex: 1, fontSize: 10.5, fontFamily: 'var(--ss-mono, monospace)', color: 'var(--ss-text-3, #6d747e)' }}>{hex}</span>
    </label>
  );
}
